/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown>, date: NonNullable<unknown> }} Coinvestments_Dataroom_Filetooltip3Inputs */

const en_coinvestments_dataroom_filetooltip3 = /** @type {(inputs: Coinvestments_Dataroom_Filetooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fileName}
Added ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{fileName} Added {date}" |
*
* @param {Coinvestments_Dataroom_Filetooltip3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetooltip3 = /** @type {((inputs: Coinvestments_Dataroom_Filetooltip3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetooltip3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetooltip3(inputs)
});
export { coinvestments_dataroom_filetooltip3 as "coInvestments_dataRoom_fileTooltip" }